import React, { useState, useEffect } from 'react';
import RequestSoftwareQuote from '../../../components/software/request-software-quote/request-software-quote.component';
import heroImageSrc from '../../../images/consulting-ehs/ehs-primary-background.png';
import Hero from '../../../components/commons/hero/hero.component';
import { getRequestSoftwareQuotePageData } from '../../../js/api/softwareForm/_requestSoftwareQuote.data';
import Loader from '../../../components/commons/helpers/loader/loader.component';

function RequestSoftwareQuotePage({ page: { modules } }) {
  // #RP - Task 69 - Request Software Quote
  const [responseMainContent, setResponseMainContent] = useState({});
  const [responseDropDownContent, setResponseDropDownContent] = useState({});
  const [status, setStatus] = useState(null);
  const [noContent] = useState(204);

  useEffect(() => {
    const fetchData = async () => {
      const getResponse = await getRequestSoftwareQuotePageData();

      if (getResponse) {
        setStatus(getResponse.status);
        setResponseMainContent(getResponse.MainContent);
        setResponseDropDownContent(getResponse.DropDownContent);
      }
    };
    fetchData();
  }, []);

  if (
    status == noContent ||
    (responseMainContent &&
      responseDropDownContent &&
      responseDropDownContent.Country != undefined)
  ) {
    return (
      <div className="software-request-page-container">
        <Hero
          src={
            status != noContent && responseMainContent.HeaderImage_src
              ? responseMainContent.HeaderImage_src
              : ''
          }
          mobileImgSrc={
            status != noContent && responseMainContent.MobileImage_src
              ? responseMainContent.MobileImage_src
              : ''
          }
          alt={
            status != noContent && responseMainContent.HeaderImage_alt
              ? responseMainContent.HeaderImage_alt
              : ''
          }
          title={
            status != noContent && responseMainContent.Title
              ? responseMainContent.Title
              : 'Please contact admin for page content'
          }
          template="standard"
          colorCategory="policies"
        />
        <div className="trinity-container">
          <RequestSoftwareQuote
            data={responseDropDownContent}
            mainData={responseMainContent}
            status={status}
          />
        </div>
      </div>
    );
  }
  return <Loader />;
}

export default RequestSoftwareQuotePage;
